import type { CollapseProps } from "antd";

import Info from "./Info";
import CDNFileDetail from "./CDNFileDetails";


export const InputStyle = { 
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};
export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "120px",
	fontSize: "15px",
};

export const panelStyle: React.CSSProperties = {
	border: "none",
};

export const EditCDNFileConstants = {
	INFO: "Genel Bilgiler",
	CDN_FILE_DETAIL: "CDN Dosyası Detayları"
};

export const EmployeeItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EditCDNFileConstants.INFO,
		children: <Info />,
		style: panelStyle,
	},	
	{
		key: "2",
		label: EditCDNFileConstants.CDN_FILE_DETAIL,
		children: <CDNFileDetail />,
		style: panelStyle,
	},
];
